import { DataTableCol } from "../../../components/tables/types";

export const BannersDataGridCols: DataTableCol[] = [
    {
        title: 'College Name',
        control: 'collegeName',
        sortable: true,
        canShowColumn: true
    },
    {
        title: 'headerImage',
        control: 'headerImage',
        sortable: true,
        canShowColumn: true
    },
    {
        title: 'Actions',
        control: 'both',
        sortable: false,
        isEdit: true,
        isDelete: true,
        canShowColumn: true
    },
];